import React from 'react';
import { SubHeading } from '../../components';
import {motion} from 'framer-motion'

import { images } from '../../constants';

import './Header.css';

const Header = () => (
  <div className="flex sm:flex-row flex-col justify-between items-center w-full min-h-screen bg-black" id="home">
  <div className='flex flex-col sm:flex-row justify-between items-center w-[80%] m-auto my-28'>

    <motion.div
     whileInView={{x:[-100, 0], opacity: [0,1]}}
    transition={{duration: 0.8, type: 'spring'}}
     className="flex flex-col sm:flex-row app__wrapper_info">
      <SubHeading title="Chase the new flavour" />
      <h1 className='app__header-h1 text-3xl sm:text-6xl font-bold text-yellow-200'>The Key to Fine Dining</h1>
      <p className="text-yellow-200 my-2 text-sm">Our secret recipe has been pass down from generation to generation,it has been perfected overtime ,also making waves across the globe, we are known far and wide...come dine with us and be astonished</p>
      <button type='button' className='custom__button'>Explore Menu</button>
    </motion.div>


    <motion.div
    whileInView={{x:[100, 0], opacity: [0,1]}}
    transition={{duration: 0.8, type: 'spring'}}
    
       className="app__wrapper_img ">
      <img src={ images.welcome} alt="header img" />
    </motion.div>
  </div>
  </div>
);

export default Header;
